import { $t } from '../../../hooks/useTranslation';
const localeText = {
    noRowsLabel: $t('There are no audit rules available.')
};
export default localeText;
